import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';

import Vas from '../../../Vas';

import '../../../css/CustomerDocumentData.css';

import { PagingTable,MessageBox } from 'component-lib';
import { DocumentsModel, RequestAjaxClass} from 'models-lib';

class CustomerDocumentData extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.Payments = [];
        this.state.CurrentView = "CustomerData";
        this.CustomerId = localStorage.getItem('employee_id') ? localStorage.getItem('employee_id'):localStorage.getItem("vas_customerId");
        this.state.Ref=this.props.me;
        this.state.Limit = 10;
        this.state.Start = 0;

        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.DocumentsModel = new DocumentsModel([this], null, this.Request);
        this.IconConfig = Vas.Config.ShowIconsOrButtons;
    }

    componentDidMount(){

      var kontrastNumber = localStorage.getItem('Kontrast');
      if(kontrastNumber == "true"){
        this.LogoClick();
      }

      this.FontSizeClick();
    }

    componentWillMount(){
      $("#LoadingIcon").removeClass().addClass('loaderSmall');
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setAuth(true);
      this.Request.setErrorHandler((data)=>{
        $("#LoadingIcon").removeClass().addClass('hide');
      });

      this.Request2.setApiUrl(Vas.ApiUrl);
      this.Request2.setApiKey(Vas.ApiKey);
      this.Request2.setAuth(true);
      this.Request2.setErrorHandler((data)=>{
        $("#LoadingIcon").removeClass().addClass('hide');
      });

      
  }

  Update(observer)
  {
      this.setState({},()=>{
        if(observer === "Documents"){
          let me =this;
          if (me.refs.table){
            me.refs.table.setState({ Data: this.DocumentsModel.Documents, Count: this.DocumentsModel.Count, Limit: this.DocumentsModel.Limit, Start: this.DocumentsModel.Start, End: this.DocumentsModel.Start + this.DocumentsModel.Documents.length });
          }
          me.setState({ Count:this.DocumentsModel.Count });
          $("#LoadingIcon").removeClass().addClass('hide');
        } 
        else if(observer === "FileParams"){
          let me =this;
          let max = me.DocumentsModel.MaxNumber;
          let number = me.state.Count;

          if (max > 0){
            if (number >= max){
              ReactDOM.render(<MessageBox 
                AppURL={Vas.ApplicationUrl} 
                Message={Vas.Resources.Labels["LimitDocuments"]} 
                Title={Vas.Resources.Titles["Note"]} />
                  , document.getElementById('messageContainer'));
            } else {
              
             Vas.GetView("CustomerDocumentUpload",{CustomerId : me.CustomerId},true);
            }
          } else {
            
            Vas.GetView("CustomerDocumentUpload",{CustomerId : me.CustomerId},true);
          }
        }
        else if(observer === "DeleteDocument"){
          let me = this;
          $("#LoadingIcon").removeClass().addClass('hide');
          if(this.DocumentsModel.DeleteSuccess === true){
            ReactDOM.render(<MessageBox 
              AppURL={Vas.ApplicationUrl} 
              Message={Vas.Resources.Labels["DocumentDeleteSuccess"]} 
              Title={Vas.Resources.Titles["Note"]} />
                , document.getElementById('messageContainer'));    
            me.load(me.refs.table.PrepareSendData());
          }else{
            ReactDOM.render(<MessageBox 
              AppURL={Vas.ApplicationUrl} 
              Message={Vas.Resources.ErrorMessages["UnexpectedError"]} 
              Title={Vas.Resources.Titles["Note"]} />
                , document.getElementById('messageContainer'));
          }
        }  
      });
      
      var kontrastNumber = localStorage.getItem('Kontrast');
  
      if(kontrastNumber == "true"){

        $('.pagingTable tbody td, .pagingTableWithoutBorder tbody td').attr('style', 'border-bottom: 1px solid #1d5c87;');
        $('#Data > tr:nth-child(2n) > td > table > tbody > tr > td').attr('style', 'background-color: none; border-bottom: none;');
        $('#Data > tr > td > table > tbody > tr > td').attr('style', 'border-bottom: none;');
        $(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseenter(function() {
          $(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        }).mouseleave(function() {
          $(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        });

        $(".selected").mouseenter(function() {
          $(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        }).mouseleave(function() {
          $(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        });

        $(".pagingTable tbody tr:nth-child(2n), .pagingTableWithoutBorder tbody tr:nth-child(2n)").attr('style', 'background-color: rgba(29, 92, 135, 0.1); border-bottom: 1px solid #1d5c87;');

        $(".loaderSmall, .loaderComponent").attr('style', 'border-top: 5px solid #1d5c87; border-bottom: 5px solid #1d5c87; z-index: 1;');
      } else {
        $('.pagingTable tbody td, .pagingTableWithoutBorder tbody td').attr('style', 'border-bottom: 1px solid #3393d3;');
        $('#Data > tr:nth-child(2n) > td > table > tbody > tr > td').attr('style', 'background-color: none; border-bottom: none;');
        $('#Data > tr > td > table > tbody > tr > td').attr('style', 'border-bottom: none;');
        $(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseenter(function() {
          $(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
        }).mouseleave(function() {
          $(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
        });

        $(".selected").mouseenter(function() {
          $(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
        }).mouseleave(function() {
          $(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
        });

        $(".pagingTable tbody tr:nth-child(2n), .pagingTableWithoutBorder tbody tr:nth-child(2n)").attr('style', 'background-color: rgba(29, 92, 135, 0.1); border-bottom: 1px solid #3393d3;');

        $(".loaderSmall, .loaderComponent").attr('style', 'border-top: 5px solid #3393d3; border-bottom: 5px solid #3393d3; z-index: 1;');
      }
    }

    load(sendData){
      this.Request.setErrorHandler((data)=>{
        $("#LoadingIcon").removeClass().addClass('hide');
      });
      this.DocumentsModel.SetRequest(this.Request);
      this.DocumentsModel.GetDocumentsByCustomerId(this.CustomerId,sendData);
    }

    Upload(){
      let me = this;
      this.Request2.setErrorHandler((data)=>{
        if (me.state.Count >= 5){
          $("#LoadingIcon").removeClass().addClass('hide');
          ReactDOM.render(<MessageBox 
            AppURL={Vas.ApplicationUrl} 
            Message={Vas.Resources.Labels["LimitDocuments"]} 
            Title={Vas.Resources.Titles["Note"]} />
              , document.getElementById('messageContainer'));
        } else {
          localStorage.setItem('DocumentSchoolUpload',false);
          Vas.GetView("CustomerDocumentUpload",{CustomerId : me.CustomerId},true);
          
        };
      });
      this.DocumentsModel.SetRequest(this.Request2);
      this.DocumentsModel.GetFileParamsByCustomerId(this.CustomerId);
    }
    
    Delete(e){
      $("#LoadingIcon").removeClass().addClass('loaderSmall');
      let id = $(e.target).parent().parent().parent().parent().parent().parent().parent("tr")[0].id;

      this.DocumentsModel.SetRequest(this.Request);
      this.DocumentsModel.DeleteDocumentByDocumentId(id);
    }

    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');
  
      if(kontrastNumber == "true"){
        $('.customerCard th, .contractCard th').attr('style', 'border-bottom: 1px solid #1d5c87;');
        $('.pagingTable th, .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');
        $('#MenuItem_Bearbeiten').attr('style', 'background-color: #1d5c87;');
        $('#MenuItem_Hinzufügen').attr('style', 'background-color: #1d5c87;');
        $(".loaderSmall, .loaderComponent").attr('style', 'border-top: 5px solid #1d5c87; border-bottom: 5px solid #1d5c87; z-index: 1;');
      } else{
        $('.customerCard th, .contractCard th').attr('style', 'border-bottom: 1px solid #3393d3;');
        $('.pagingTable th, .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #3393d3; border-bottom: 1px solid #3393d3;');
        $('#MenuItem_Bearbeiten').attr('style', 'background-color: #3393d3;');
        $('#MenuItem_Hinzufügen').attr('style', 'background-color: #3393d3;');
        $(".loaderSmall, .loaderComponent").attr('style', 'border-top: 5px solid #3393d3; border-bottom: 5px solid #3393d3; z-index: 1;');
      }
    }

    FontSizeClick(){
      var schriftgröße = localStorage.getItem('Schriftgröße');
  
      //Schriftgröße bei Klick in 2er Schritten erhöhen
  
        if(schriftgröße != null){
              switch(schriftgröße){
                case "0":
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#customerCardHeadline').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");
  
                break;
                case "1":
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#customerCardHeadline').removeClass("Schriftgröße_22").addClass("Schriftgröße_17");
  
                break;
                case "2":
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#customerCardHeadline').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
  
                break;
                case "3":
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#customerCardHeadline').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
  
                break;
                case "4":
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#customerCardHeadline').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
  
                break;
                case "5":
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#customerCardHeadline').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
  
                break;
              }
        }
    };

    render()
    {  
        let upload='';
        if (this.state.Upload === true){
            upload=(<div 
              className={"paymentDetails"} 
              id={"uploadDocument"} >
            </div>);
        } else {
            upload=<div></div>;
        }

        return (
          <div id={"customerDocuments"}>
            <div id={"customerCardHeadline"} style={{ paddingTop: '10px', paddingLeft: '10px', fontSize: 'calc(15px + 0.2vw)' }}><b>{Vas.Resources.Labels["Documents"]}</b></div>
            <table  >
              <tbody>
                <tr>
                  <td>
                    <PagingTable 
                      ref="table" 
                      TableReference={this} 
                      DataBaseTable={"Dokumente"} 
                      Selectable={false} 
                      Limit={this.state.Limit} 
                      Start={this.state.Start} 
                      End={this.state.End} 
                      Count={this.state.Count} 
                      Columns={[Vas.Resources.Labels["DocumentName"],Vas.Resources.Labels["Size"],Vas.Resources.Labels["Action"]]}
                      Keys={["FileName","FileSize"]}
                      Data={this.state.Data} 
                      Download={true} 
                      Add={true} 
                      AddClick={()=>{this.Upload();}}
                      Border={false}
                      DownloadType={"Document"}
                      AppURL={Vas.ApplicationUrl} 
                      SelectFieldChooseText={Vas.Resources.Labels["PleaseChoose"]} 
                      ApiURL={Vas.ApiUrl} 
                      ApiKey={Vas.ApiKey}
                      Token={localStorage.getItem('vas_token')}
                      TooltipSearchName={Vas.Resources.Tooltips["SearchName"]} 
                      TooltipCsvDownload={Vas.Resources.Tooltips["CsvDownload"]}
                      LabelPage={Vas.Resources.Labels["Page"]} 
                      LabelOf={Vas.Resources.Labels["Of"]} 
                      LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
                      Modus={"Abellio"}
                      Delete={true} 
                      DeleteOnClick={(e)=>{this.Delete(e);}} 
                      AddString={Vas.Resources.Labels["Add"]}
                      ShowIcons={this.IconConfig.ShowIcons}
                      UseBurgerMenu={false}
                       />
                  </td>
                </tr>
                <tr>
                  <td>
                    {upload}  
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
    }
}
export default CustomerDocumentData;
